import { createContext as t } from "react";
const e = t(
  () => {
  }
);
export {
  e as InputGroupContext
};
//# sourceMappingURL=utils.js.map
